import React from "react";
import "./PortraitReveal.css";

import { motion } from "framer-motion";

const ease = [0.83, 0, 0.17, 1];
const src = `${process.env.PUBLIC_URL}/mounir-el-majdoub-320.avif`;

// reuses the exact feature-image reveal from the project detail page:
// a left-to-right clip-path wipe with the inner image scaling 1.5 -> 1
const PortraitReveal = ({ className = "", delay = 0, alt = "Mounir El Majdoub" }) => (
  <motion.div
    className={`portrait ${className}`}
    initial={{
      clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
      transition: { duration: 0.15, ease, delay },
    }}
    animate={{
      clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
      transition: { duration: 1.75, ease, delay },
    }}
  >
    <motion.img
      src={src}
      alt={alt}
      decoding="async"
      initial={{ scale: 1.5, transition: { duration: 0.15, ease, delay: 0 } }}
      animate={{ scale: 1, transition: { duration: 1.75, ease, delay: 0 } }}
    />
  </motion.div>
);

export default PortraitReveal;
